export default {
  searchPlaceholder: "البحث عن وسم محدد",
  selectedTags: "الاوسمة الى تم اختيارها",
  doesNotExist: "غير موجود",
  title: "ما الذي يميز المتجر؟",
  setupBrand: "أوسمة المتجر",
};
